/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const sitekitTokens = {
  CoreLogoSizeHeight: '32px',
  CoreSidebarBackgroundColor: '#ebecec',
  CoreHeadlineBackgroundColorInitial: 'rgba(0, 0, 0, 0)',
  CoreHeadlineBackgroundColorHover: '#dedfdf',
  CoreHeadlineBackgroundColorSelected: '#c4c4c4',
  CoreHeadlineBackgroundColorActive: '#c4c4c4',
  CoreUtilityBackgroundColorInitial: 'rgba(0, 0, 0, 0)',
  CoreUtilityBackgroundColorHover: '#dedfdf',
  CoreUtilityBackgroundColorSelected: '#c4c4c4',
  CoreUtilityBackgroundColorActive: '#c4c4c4',
} as const;
